var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsLetter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Promotion"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.64844 31.23828-27-23a.99989.99989 0 0 0 -1.29688 0l-27 23a1.0017 1.0017 0 0 0 .11524 1.6084l27 17a1.00381 1.00381 0 0 0 1.0664 0l27-17a1.0017 1.0017 0 0 0 .11524-1.6084z",
    fill: "#f79326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 8h-34a4.004 4.004 0 0 0 -4 4v42a.99943.99943 0 0 0 1 1h40a.99943.99943 0 0 0 1-1v-42a4.004 4.004 0 0 0 -4-4z",
    fill: "#6fa0ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.99219 18.876a1.00055 1.00055 0 0 0 -.99219-.876h-6a1.0002 1.0002 0 0 0 -.93652 1.35156l3 8a1.00076 1.00076 0 0 0 .93652.64844h4a.999.999 0 0 0 .99219-1.124z",
    fill: "#f22a55"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 13,
    fill: "#ff5876",
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 13,
    fill: "#c3dbfc",
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.48438 2.125a1.00159 1.00159 0 0 0 -1.01465.02734l-2.8418 1.77637a29.3804 29.3804 0 0 1 -10.792 4.085.99947.99947 0 0 0 -.83593.98629v8a.99947.99947 0 0 0 .83594.98633 29.3804 29.3804 0 0 1 10.792 4.085l2.8418 1.77637a.99974.99974 0 0 0 1.53026-.8477v-20a1.00106 1.00106 0 0 0 -.51562-.875z",
    fill: "#c3dbfc"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ff5876",
    height: 14,
    rx: 2,
    width: 12,
    x: 30,
    y: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 12h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2z",
    fill: "#f22a55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 16h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2z",
    fill: "#f22a55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.55762 31.16992a.99322.99322 0 0 0 -.93457-.0957l-26.62305 10.8457-26.623-10.8457a.99954.99954 0 0 0 -1.377.92578v31a.99943.99943 0 0 0 1 1h54a.99943.99943 0 0 0 1-1v-31a1.00022 1.00022 0 0 0 -.44238-.83008z",
    fill: "#ffc751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 62.57v.43a1.003 1.003 0 0 1 -1 1h-54a1.003 1.003 0 0 1 -1-1v-.44l24.04-22.25 3.28-3.04a.99129.99129 0 0 1 1.36 0l3.28 3.04z",
    fill: "#ffe176"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5a8ae0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22 14h-9a1 1 0 0 1 0-2h9a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 19h-11a1 1 0 0 1 0-2h11a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 24h-15a1 1 0 0 1 0-2h15a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 29h-15a1 1 0 0 1 0-2h15a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 34h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2z"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#a9c5ed",
    height: 26,
    rx: 2,
    width: 6,
    x: 54
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsLetter);
export default __webpack_public_path__ + "static/media/news_letter.0876f30c2d7f477d8f0d0fbc77ed597b.svg";
export { ForwardRef as ReactComponent };